import React from "react";
import PropTypes from "prop-types";
import {withNamespaces} from "react-i18next";

const FOCUS_AREA_LABELS = {
  fuel_your_body: 'trainer_day_focus_fuel',
  know_your_numbers: 'trainer_day_focus_numbers',
  master_the_machines: 'trainer_day_focus_machines',
  train_with_a_plan: 'trainer_day_focus_plan',
};

const BookingSuccess = (props) => {
  const isEarlySale = props.preSale;
  const isTrainerDay = props.eventType === 'training-day';

  return (
    <div className='booking-success-component'>
      <div className='booking-success-header'>
        <div className='booking-success-header-wrapper'>
          <h1 className='white'>{props.t(
            isEarlySale ? 'early_sale_success_header'
              : isTrainerDay ? 'trainer_day_success_header'
                : 'booking_success_header'
          )}</h1>
          <h3 className='white'>
            <p>{props.t(
              isEarlySale ? 'early_sale_success_line1'
                : isTrainerDay ? 'trainer_day_success_subheader_line1'
                  : 'booking_success_subheader_line1'
            )}</p>
            <p>{props.t(
              isEarlySale ? ''
                : isTrainerDay ? 'trainer_day_success_subheader_line2'
                  : 'booking_success_subheader_line2'
            )}</p>
          </h3>
        </div>
      </div>

      <div className='booking-success-body'>
        {!isEarlySale && (
          <h2>{props.t('booking_success_details')}</h2>
        )}

        {!isEarlySale && isTrainerDay && props.focusArea && (
          <p className='booking-success-focus-area'>{props.t('trainer_day_success_focus_area', {focus_area: props.t(FOCUS_AREA_LABELS[props.focusArea])})}</p>
        )}

        {!isEarlySale && (
          <div className='booking-success-details'>
            <div>
              <i className='fa fa-calendar'></i>
              <p className='bold'>{props.t(`booking_success_day${props.slot.start_date_time.getDay()}`)}</p>
              <p className='small'>{props.t(`booking_success_month${props.slot.start_date_time.getMonth()}`)} {props.slot.start_date_time.getDate()}</p>
            </div>

            <div>
              <i className='fa fa-clock-o'></i>
              <p className='bold'>{props.slot.getStartTime()}</p>
              <p className='small'>{props.t(isTrainerDay ? 'trainer_day_success_duration' : 'booking_success_duration', {duration: props.event.duration})}</p>
            </div>

            <div>
              <i className='fa fa-map-marker'></i>
              <p className='bold'>{props.member.club.name}</p>
              <p className='small'>{props.member.club.address.address_1} {props.member.club.address.address_2}</p>
            </div>
          </div>
        )}

        {!isTrainerDay && (
          <div className='booking-success-why'>
            <p className="bold">{props.t('booking_success_why_header')}</p>
          </div>
        )}

        <div className='booking-success-confirmation'>
          <p dangerouslySetInnerHTML={{ __html: props.t(isEarlySale ? '' : 'booking_success_confirmation_header', {email: props.member.email})}} />
          <p dangerouslySetInnerHTML={{ __html: props.t(isEarlySale ? 'early_sale_success_schedule_later' : 'booking_success_confirmation_header2', {club_name: props.member.club.name, phone: props.member.club.phone})}} />
          <h3 dangerouslySetInnerHTML={{__html: props.t('booking_success_we_wait_you')}} />

          <a href="/" className='form-main-button'>{props.t('booking_success_profile_btn')}</a>
        </div>
        {!isTrainerDay && (
          <div className='footnote'>
            <p className="italic">{props.t('booking_success_why_subheader')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

BookingSuccess.propTypes = {
  event: PropTypes.object,
  member: PropTypes.object,
  slot: PropTypes.object,
  preSale: PropTypes.bool,
}

export default withNamespaces()(BookingSuccess);